import * as moment from 'moment';

export function formatMessageTime(date: any): string {
  return moment(date).format('HH:mm');
}

// day separator between messages: "Today", "Yesterday", a weekday within the last week, otherwise the date
export function formatChatDay(date: any): string {
  const day = moment(date);
  if (day.isSame(moment(), 'day')) {
    return 'Today';
  }
  if (day.isSame(moment().subtract(1, 'day'), 'day')) {
    return 'Yesterday';
  }
  if (day.isAfter(moment().subtract(7, 'days'), 'day')) {
    return day.format('dddd');
  }
  return day.format('MM/DD/YYYY');
}

// time of the last message in the conversations list: the time today, otherwise the day
export function formatChatListTime(date: any): string {
  if (moment(date).isSame(moment(), 'day')) {
    return formatMessageTime(date);
  }
  return formatChatDay(date);
}

export function isSameChatDay(firstDate: any, secondDate: any): boolean {
  return moment(firstDate).isSame(moment(secondDate), 'day');
}
